// ----------------------------------------------------
// src/Redux/Slices/ReviewSlice.js
// ----------------------------------------------------

import { createSlice } from '@reduxjs/toolkit';
import reviewData from '../../Json/ReviewData.json';

const reviewSlice = createSlice({
  name: 'review',
  initialState: {
    data: reviewData,
  },
  reducers: {},
});

export default reviewSlice.reducer;